<template>
  <div>
    <BookingTable :fields="fields" :isAdmin="true" />
  </div>
</template>

<script>
import BookingTable from "../../../components/bookings/BookingTable";

export default {
  components: { BookingTable },
  data() {
    return {
      fields: [
        {
          key: "name",
          label: this.$t("utils.table.name"),
          tdClass: "name"
        },
        {
          key: "email",
          label: this.$t("login.form.email-placeholder")
        },
        {
          key: "purchase_date",
          label: this.$t("utils.table.purchase-date"),
          sortable: true
        },
        {
          key: "booking_date",
          label: this.$t("utils.table.booked-at")
        },
        {
          key: "city",
          label: this.$t("coworking-info.coworking-form.city-placeholder")
        },
        {
          key: "space",
          label: this.$t("utils.space")
        },
        {
          key: "delete",
          label: "",
          tdClass: "delete"
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch(
      "utils/setSectionName",
      `${this.$t("sidebar.menu.bookings")}`
    );
    this.$store.dispatch("sidebar/setAction", null);
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/superadmin/bookings/BookingsPage.vue